export default __webpack_public_path__ + "static/media/perso-events.0aaf4214.png";